import React from 'react';
import '../../styles/input.css';

const Input = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  hint,
  required = false,
  disabled = false,
  readOnly = false,
  icon = null,
  className = '',
  rows,
  min,
  max,
  step,
  children, // For select options
  ...props
}) => {
  const inputId = `input-${name}-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`input-wrapper ${className}`}>
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label}
          {required && <span className="required-mark">*</span>}
        </label>
      )}
      
      <div className="input-container">
        {icon && type !== 'textarea' && type !== 'select' && <span className="input-icon">{icon}</span>}
        
        {type === 'textarea' ? (
          <textarea
            id={inputId}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            rows={rows || 3}
            className={`input-field ${error ? 'error' : ''}`}
            {...props}
          />
        ) : type === 'select' ? (
          <select
            id={inputId}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            className={`input-field ${error ? 'error' : ''}`}
            {...props}
          >
            {children}
          </select>
        ) : (
          <input
            id={inputId}
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            min={min}
            max={max}
            step={step}
            className={`input-field ${error ? 'error' : ''} ${icon ? 'has-icon' : ''}`}
            {...props}
          />
        )}
      </div>
      
      {hint && !error && <span className="input-hint">{hint}</span>}
      {error && <span className="input-error">{error}</span>}
    </div>
  );
};

export default Input;